import * as Yup from "yup";

export const facilitySchema = Yup.object().shape({
  name: Yup.string().required("Facility name is required"),
  description: Yup.string().nullable(),
  institution_id: Yup.string().required("Institution is required"),
});
